export default __webpack_public_path__ + "41aafbaddc0f59a3ca00898f94530335.svg";